// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","body":"_2lYHSCAcM6vA2s-47YYZeS","button":"_2JtmVDW7dlC6yYNIkhaX_y","customWhite":"#ffffff","customGreyFaded":"#f7f9fc","mediumMaxWidth":"1199px","primaryGreen":"#028154","separatorGrey":"#eceeee","textBlack":"#161616","title":"_2hh51fd3CqkIUwQQAnzlTc _2IbHD4FVxtBnbNHEUw2mS3","mobileThreshold":"575px","content":"VqRJa6fUKAk_uFYoM5W_l","menu":"B6Y8kTn2pbavFQTTHaJ4D _2lYHSCAcM6vA2s-47YYZeS","menuItem":"_1r7gxzSjkf0FvH3_CQHbGc _2JtmVDW7dlC6yYNIkhaX_y","menuItemSelected":"UUtBh9f9_gy2Du4Q2uRou _2JtmVDW7dlC6yYNIkhaX_y"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/information-menu/InformationMenu.css
// module id = 1110
// module chunks = 2